import { z } from 'zod';
import { zDocketStatus, zDocketType, zPrinterInterface } from '../enums';
import { printAttemptSchema } from './printAttemptSchema';

export const docketSchema = z.object({
  actualPosPrinterIdentifier: z.string(),
  actualPosPrinterInterface: zPrinterInterface,
  desiredPosPrinterIdentifier: z.string(),
  /**
   * base64 image data string for debugging purposes only
   */
  debugImageBase64: z.string().nullable().default(null),
  docketPayload: z.string().nullable().default(null),
  docketTemplateUuid: z.string(),
  docketType: zDocketType,
  expireAt: z.number(),
  localCreatedAt: z.number(),
  localUpdatedAt: z.number(),
  printAttempts: z.array(printAttemptSchema).default([]),
  printJobUuid: z.string().nullable().default(null),
  /** Set on a docket its printer gave up on once a fresh copy was queued on a physical fallback
   *  printer (`rerouteFailedDocket`). The copy now carries the docket to the kitchen, so this one is
   *  an audit record, not a docket that didn't print. */
  reroutedToDocketUuid: z.string().nullable().default(null).optional(), // Remove .optional() once stored dockets have it
  /** Staff are offered a retry when this docket fails. A cash drawer request is not worth one. */
  shouldRetry: z.boolean(),
  status: zDocketStatus,
  uuid: z.string(),
});
export type Docket = z.output<typeof docketSchema>;

export const docketStrictSchema = docketSchema.safeExtend({
  docketTemplateUuid: z.guid(),
  printJobUuid: z.guid().nullable(),
  reroutedToDocketUuid: z.guid().nullable().default(null).optional(),
  uuid: z.guid(),
});
